export default __webpack_public_path__ + "static/media/Nightlord Bracers.db74eebe.jpg";